function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.337 12.77l-2.062-1.995-1.044 1.08 3.175 3.07 4.807-5.282-1.11-1.01zm6.61 4.193c0 .413-.336.75-.749.75H2.252a.751.751 0 0 1-.75-.75V3.753c0-.414.336-.75.75-.75H3.49v2.964h7.506V3.002h1.2c.414 0 .751.337.751.75zM6.492 3.003v-.751a.751.751 0 0 1 1.502 0v.75h1.5v1.464H4.992V3.002zM9.366 1.5A2.256 2.256 0 0 0 7.243 0C6.264 0 5.43.627 5.12 1.501H2.252A2.254 2.254 0 0 0 0 3.753v13.21a2.254 2.254 0 0 0 2.252 2.251h9.947a2.255 2.255 0 0 0 2.25-2.251V3.753A2.254 2.254 0 0 0 12.196 1.5z"
})));

var SvgDotAudit = function SvgDotAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotAudit.e43b850e.svg";
export { ForwardRef as ReactComponent };